<template>
    <div v-if="active" class="wechat-tips" @click="close()">
        <img class="icon" src="~@/assets/imgs/common/icon-wechat-tip.png" />
    </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'

import BaseComponent from '@/BaseComponent'

/** 微信内下载引导提示
 *
 * @author
 * @create 2021-11-26 (星期五)
 */
@Component({ name: 'wechat-tips', components: {} })
export default class extends BaseComponent {
    /* props, data, getter */
    /** 视图控制 */
    active: boolean = false
    callback!: Function
    /* life event: [mounted, beforeDestory] */

    /* methods */
    /** 打开 */
    open(): Promise<void> {
        return new Promise((resolve) => {
            this.active = true
            this.callback = resolve
        })
    }

    /** 关闭 */
    close(): void {
        this.active = false
        this.callback?.()
    }
}
</script>

<style lang="less" scoped>
.wechat-tips {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    animation: fadeIn 0.3s linear forwards;
    .icon {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1;
        width: 100%;
    }
}
</style>
